import { cn } from '@/utils/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('rounded-sm bg-primary/10', className)} {...props} />
  );
}

function SkeletonLoader({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-sm bg-[length:400%_100%] animate-loading bg-gradient-to-r from-muted-foreground/10 via-muted-foreground/30 to-muted-foreground/10 bg-fixed',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton, SkeletonLoader };
